<ng-container>
  <section class="text--small text--gray spacing--padding-top">{{ 'cart-overview.total-amount.title-sales-period' | translate }}</section>
  <div *ngFor="let salesPeriod of salesPeriods$ | async" class="flex-container">
    <div class="name-date-container">
      <span class="text--large sales-period-name">{{ salesPeriod.name }}</span>
      <span class="text--small text--gray sales-period-date-range">
        {{ salesPeriod.dateFrom | agrDate }}
        {{ 'cart-overview.total-amount.sales-order-period-to' | translate }}
        {{ salesPeriod.dateTo | agrDate }}
      </span>
    </div>
    <div class="price-container">
      <span class="spinner-container" *ngIf="!salesPeriod.hasCalculatedAllPrices">
        <mat-spinner diameter="21" class="spacing--margin-right"></mat-spinner>
        <span class="spinner-text blink-soft">{{ 'cart-overview.total-amount.priceSpinnerText' | translate }}</span>
      </span>
      <span *ngIf="salesPeriod.hasCalculatedAllPrices" class="text--large total-price">{{ salesPeriod.totalPrice | agrCurrency: salesPeriod.currency }}</span>
    </div>
  </div>
</ng-container>
